import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { copyText } from "./staffUtils";

// What happened to a send / resend: {tone: ok|warn|error|info, text}.
export function deliveryMessage(channel, delivery) {
  const d = delivery || {};
  const where = d.destination_masked ? ` to ${d.destination_masked}` : "";
  if (channel === "link") return { tone: "info", text: "Link ready. Copy it and share it with the patient." };
  if (channel === "kiosk") return { tone: "info", text: "Tablet session ready." };
  if (d.sent) return { tone: "ok", text: channel === "email" ? `Sent by email${where}.` : `Sent by text${where}.` };
  if (d.blocked) {
    return {
      tone: "warn",
      text: channel === "email"
        ? "Email is turned off for this practice; use Copy link or Tablet"
        : "Texting is turned off for this practice; use Copy link or Tablet",
    };
  }
  return { tone: "error", text: `Couldn't send${d.error ? `: ${d.error}` : ""}. Use Copy link, or try Resend later.` };
}

// The one-time link with a Copy button (clipboard API, textarea fallback).
export default function LinkBox({ link }) {
  const [copied, setCopied] = useState(false);
  if (!link) return null;
  return (
    <div className="fws-stack">
      <div className="fws-linkbox">
        <input className="fws-input" readOnly value={link} aria-label="Form link" onFocus={(e) => e.target.select()} />
        <button
          type="button"
          className="fws-btn fws-btn-primary"
          onClick={async () => {
            setCopied(await copyText(link));
          }}
        >
          <ContentCopyIcon fontSize="small" /> {copied ? "Copied" : "Copy link"}
        </button>
      </div>
      <div className="fws-help">
        This link is shown only once. To get a new one later, use Resend (the old link stops working).
      </div>
    </div>
  );
}
